import React from "react";
import PropTypes from "prop-types";
import {
  buttonName,
  fundedInvoicesData,
  processing,
  tooltips
} from "../../../../locales/en";

const QuoteFooter = ({
  checkboxId,
  isChecked,
  onCheckboxChange,
  checkboxError,
  onDownload,
  onAccept,
  isLoading,
  contentKey,
  quoteLoading
}) => {
  const content = fundedInvoicesData?.toFund?.[contentKey];

  return (
    <div className="quote-footer text-center">
      <div className="quote-checkbox d-flex justify-content-center align-items-center">
        <input
          type="checkbox"
          className="mr-1 me-2"
          id={checkboxId}
          checked={isChecked}
          onChange={() => {
            onCheckboxChange();
          }}
        />
        <label
          htmlFor={checkboxId}
          className="d-flex justify-content-center align-items-center pt-1"
        >
          {content}
          <button
            className={`quote-dwnload-btn ${quoteLoading ? "loading-btn-qt" : ""}`}
            onClick={onDownload}
            disabled={quoteLoading}
          >
            {quoteLoading ? (
              <span className="loading-quote">
                {buttonName?.loadingWait}
                <span className="dots" />
              </span>
            ) : (
              tooltips?.quote
            )}
          </button>
        </label>
      </div>
      {checkboxError && (
        <div className="text-danger small mt-1">
          <p>{fundedInvoicesData?.toFund?.content5}</p>
        </div>
      )}
      <div className="accept-btn-wrap mb-3 mt-3">
        <button
          className="btn btn-primary accept-btn"
          onClick={onAccept}
          disabled={isLoading}
        >
          {isLoading ? processing : fundedInvoicesData?.btnGroup?.acceptQuote}
        </button>
      </div>
    </div>
  );
};

QuoteFooter.propTypes = {
  checkboxId: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  checkboxError: PropTypes.bool,
  onDownload: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  quoteLoading: PropTypes.bool,
  contentKey: PropTypes.string.isRequired
};

QuoteFooter.defaultProps = {
  checkboxError: false,
  isLoading: false
};

export default QuoteFooter;
